import axios from 'axios';

let logoutHandler = null;
export const setLogoutHandler = (fn) => {
    logoutHandler = fn;
};

// Basis-URL des Flask-Backends
const API_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Axios Interceptor für JWT
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

// Axios Interceptor für redirect wenn nicht eingeloggt
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401 && logoutHandler) {
            logoutHandler();
        }
        return Promise.reject(error);
    }
);

// --- Auth Endpunkte ---
export const login = (credentials) => api.post('/login', credentials);

// --- Admin Endpunkte ---
export const getSourceSystems = () => api.get('/admin/systems');
export const createSourceSystem = (name, description) => api.post('/admin/systems', { name, description });

// --- Statistik Endpunkte ---
export const getStatsPerSystem = () => api.get('/stats/statements-per-system');
export const getStatsOverTime = () => api.get('/stats/statements-over-time');
export const getMostFrequentVerbs = () => api.get('/stats/most-frequent-verbs');
export const getTopActors = () => api.get('/stats/top-actors');

// ----- Mongo Browser Endpoints ------------------------------------
export const getCollections = () => api.get("/mongo/collections").then(r => r.data);

export const getCollectionRecords = (collection, payload) =>
    api
        .get(`/mongo/${collection}`, { params: payload })
        .then(r => r.data); // { total, docs }

export const getRecord = (collection, id) =>
    api.get(`/mongo/${collection}/${id}`).then(r => r.data);

export const updateRecord = (collection, id, data) =>
    api.put(`/mongo/${collection}/${id}`, data).then(r => r.data);

export const createRecord = (collection, data) =>
    api.post(`/mongo/${collection}`, data).then(r => r.data);

export const deleteRecord = (collection, id) =>
    api.delete(`/mongo/${collection}/${id}`).then(r => r.data);


export default api;